import { IForm } from 'core-components/classes/models/IForm'

export default class ValidationHelper {
  public static checkPercent = async (value: string, treshold?: number) => {
    if (isNaN(parseFloat(value))) {
      return 'Incorrect percent'
    }

    return Number(value) <= 100 && Number(value) >= (treshold ? treshold : 0)
      ? ''
      : 'Incorrect percent'
  }

  public static checkNullablePercent = async (value: string | null, treshold?: number) => {
    if (value === null || value === '') {
      return ''
    }

    if (isNaN(parseFloat(value))) {
      return 'Incorrect percent'
    }

    return Number(value) <= 100 && Number(value) >= (treshold ? treshold : 0)
      ? ''
      : 'Incorrect percent'
  }

  public static check100Percent = async (value: string) => {
    if (isNaN(parseFloat(value))) {
      return 'Incorrect percent'
    }

    return Number(value) === 100 ? '' : 'Incorrect total percent'
  }

  public static checkNumber = async (value: string | number) => {
    return Number(value) >= 0 ? '' : 'Incorrect value'
  }

  public static checkNullableNumber = async (value: string | number | null) => {
    if (value === null || value === '') {
      return ''
    }

    return Number(value) >= 0 ? '' : 'Incorrect value'
  }

  public static checkNumberRequired = async (
    value: string,
    message: string = 'Incorrect value',
    allowNegative: boolean = false
  ) => {
    const numberVal = Number(value)
    const isValid = value !== '' && (allowNegative ? !!numberVal : numberVal >= 0)

    return isValid ? '' : message
  }

  public static checkNullableNumberRequired = async (
    value: any,
    message: string = 'Incorrect value',
    aboveZero: boolean = false
  ) => {
    return (!!value || value == 0) &&
      value !== '' &&
      (aboveZero ? Number(value) > 0 : Number(value) >= 0)
      ? ''
      : message
  }

  public static calcPercent = (field1?: number, field2?: number, round = false) => {
    const val1 = field1 == null ? 0 : field1
    const val2 = field2 == null ? 0 : field2
    if (val1 === 0 && val2 === 0) {
      return '0'
    }
    if (val2 === 0 && val1 > 0) {
      return '-'
    }
    const val = (100 * val1) / val2

    return round ? Math.round(val).toString() : val.toFixed(1)
  }

  public static checkString = async (
    value: string,
    errStr: string = "The value shouldn't be empty"
  ) => {
    return value.length > 0 ? '' : errStr
  }

  public static checkEmail = async (value: string) => {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
      ? ''
      : 'Please, enter a correct email'
  }

  // FirstName LastName <name@domain.com>
  public static checkFullEmail = async (value: string, domains?: string[], message?: string) => {
    let isValid = false

    const fullEmailRegex =
      /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g
    isValid = fullEmailRegex.test(value)
    if (isValid && !!domains?.length) {
      isValid = !!domains.filter(
        (domain) =>
          (value || '').toLocaleLowerCase().indexOf((domain || '').toLocaleLowerCase()) >= 0
      ).length
    }

    return isValid ? '' : message || 'Please, enter a correct email'
  }

  public static checkDropdown = async (value: string, source: IForm[], field: string) => {
    return source.find((el) => (el[field] || '').toString() === value)
      ? ''
      : 'Please, select a value'
  }

  public static checkMultiselect = async (
    value: string,
    source: IForm[],
    field: string,
    separator = ',',
    required?: boolean
  ) => {
    const vals = value.split(separator)
    if (!vals.length) {
      return required ? 'Please, select a value' : ''
    }
    let err = false
    vals.map((v) => {
      err = err || !source.find((el) => el[field] === v)
    })

    return err ? 'Please, select a proper value' : ''
  }

  public static checkFinancialYear = (value: string, fyear?: number) => {
    const currYear = fyear || new Date().getFullYear()
    const startFY = new Date(currYear - 1, 10, 1)
    const endFY = new Date(currYear, 9, 31)
    const currDate = value ? new Date(value) : new Date()
    const result = currDate >= startFY && currDate <= endFY

    return result ? '' : 'Please, select a date from current Financial Year'
  }

  public static checkQuarter = async (value: string) => {
    const val = Number(value)

    return val >= 1 && val <= 4 ? '' : 'Please, enter a correct Quarter'
  }

  public static getPercentValue = (value: string) => {
    return value === '-' ? value : value + '%'
  }
}
